export const STRIPE_CONFIG = {
  products: {
    starter: {
      name: 'Starter',
      prices: {
        monthly: process.env.NEXT_PUBLIC_STRIPE_STARTER_MONTHLY_PRICE_ID || 'price_starter_monthly',
        annual: process.env.NEXT_PUBLIC_STRIPE_STARTER_ANNUAL_PRICE_ID || 'price_starter_annual',
      },
    },
    pro: {
      name: 'Pro',
      prices: {
        monthly: process.env.NEXT_PUBLIC_STRIPE_PRO_MONTHLY_PRICE_ID || 'price_pro_monthly',
        annual: process.env.NEXT_PUBLIC_STRIPE_PRO_ANNUAL_PRICE_ID || 'price_pro_annual',
      },
    },
    unlimited: {
      name: 'Unlimited',
      prices: {
        monthly: process.env.NEXT_PUBLIC_STRIPE_UNLIMITED_MONTHLY_PRICE_ID || 'price_unlimited_monthly',
        annual: process.env.NEXT_PUBLIC_STRIPE_UNLIMITED_ANNUAL_PRICE_ID || 'price_unlimited_annual',
      },
    },
  },
  pricing: {
    starter: {
      monthly: 29,
      annual: 197,
    },
    pro: {
      monthly: 79,
      annual: 497,
    },
    unlimited: {
      monthly: 199,
      annual: 1297,
    },
  },
};

export type PlanTier = 'free' | 'starter' | 'pro' | 'unlimited';
export type BillingCadence = 'monthly' | 'annual';

export const PLAN_LIMITS = {
  free: {
    activeCases: 1,
    exports: 0,
    docGenerations: 0,
    fullQuizAccess: false,
  },
  starter: {
    activeCases: 1,
    exports: 3,
    docGenerations: 5,
    fullQuizAccess: false,
  },
  pro: {
    activeCases: 5,
    exports: 50,
    docGenerations: 100,
    fullQuizAccess: true,
  },
  unlimited: {
    activeCases: -1, // unlimited
    exports: -1, // unlimited
    docGenerations: -1, // unlimited
    fullQuizAccess: true,
  },
};
